import apiClient from "./client";

export async function getNotificationsUnreadCount() {
  return apiClient.get("/notifications/me/unread-count");
}

export async function getNotifications(params = {}) {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value != null && value !== "") qs.set(key, String(value));
  });
  const suffix = qs.toString() ? `?${qs.toString()}` : "";
  return apiClient.get(`/notifications/me${suffix}`);
}

export async function markNotificationRead(notificationId) {
  return apiClient.post(`/notifications/${notificationId}/read`, {});
}

export async function markAllNotificationsRead() {
  return apiClient.post("/notifications/read-all", {});
}
